import React from 'react';
import { motion } from 'framer-motion';
import college from "../../assets/Home/college.jpg";
import principal from "../../assets/Home/principal.jpg";
import SidebarGalleryPage from "../../Components/Main/Sidebargallery";

const Principaldesk = () => {
  return (
    <div className="bg-gray-100 min-h-screen p-10 flex flex-col lg:flex-row gap-8">
      <div className="w-full lg:w-2/3 space-y-8">
        {/* Animated College Image */}
        <motion.img
          src={college}
          alt="College"
          className="w-full shadow-lg border-4 border-teal-500 rounded-lg"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        />

        {/* Principal's Desk Section */}
        <motion.div
          className="bg-white rounded-lg shadow-lg border-4 border-teal-500 p-8"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-white bg-teal-500 py-4 text-2xl font-bold rounded-md text-center shadow-md">
            From Principal’s Desk
          </h2>
          <div className="p-6 flex flex-col md:flex-row items-start gap-8">
            {/* Image Section */}
            <motion.div
              className="border-2 border-black p-4  bg-gray-100 text-center shadow-md"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={principal}
                alt="Principal"
                className="w-44 h-44 object-cover rounded-lg"
              />
              <p className="font-bold mt-2 text-lg">Principal</p>
              <p className="font-semibold text-gray-700">Mr. D.R Verma</p>
            </motion.div>

            {/* Description Section */}
            <motion.div
              className="flex-1 text-gray-800 text-lg leading-relaxed"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <p className="mb-4">
                Technical Education plays an important role in the development
                of the country. It is the backbone of infrastructure, industry,
                and economic growth.
                <span className="font-bold text-black">
                  {" "}
                  Govt. Women Polytechnic College Sehore (M.P.)
                </span>{" "}
                runs under the{" "}
                <span className="font-bold text-black">
                  Dr. Baba Saheb Ambedkar
                </span>{" "}
                scheme for Scheduled Caste girls, aiming to enhance technical
                education among women in the region.
              </p>
              <p className="mb-4">
                The institution was{" "}
                <span className="font-bold text-black">
                  established in 1998
                </span>{" "}
                and offers AICTE-approved diploma programs.
              </p>
              <p className="font-bold text-center">
                We once again extend a warm welcome to the viewers of this
                website
              </p>
              <div className="text-right font-semibold mt-6 p-4 ">
                <p>Principal</p>
                <p>Mr. D.R. Verma </p>
                {/* <p>GOVERNMENT WOMEN’S POLYTECHNIC COLLEGE SEHORE</p> */}
                <p>
                  Mobile: <span className="font-normal">9826944591</span>
                </p>
                {/* <p>Mobile: <span className="font-normal">XXXXXXX</span></p> */}
                <p>
                  Email:{" "}
                  <span className="font-normal">prinwpoly.seh@mp.gov.in</span>
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Right Section: Gallery */}
      <div className="w-full lg:w-1/3">
        <SidebarGalleryPage />
      </div>
    </div>
  );
};

export default Principaldesk;
